import { createComparingLifecycle } from "./lifecycle";
export function onDidUpdate(callback) {
  return createComparingLifecycle("componentDidUpdateCallback", callback);
}
export default onDidUpdate;